'use client';

import { c as _c } from "react/compiler-runtime";
import { MetricCard, StatisticCard } from '@/components/Metrics/MetricCard';
import { useMatchMedia } from '@/hooks';
import { type StructuredDocs } from '@/payload/blocks/TopicBlock/utils';
import { calculateBorders, cn, type GroupedItem } from '@tallinn-arvudes/ui/utils';
import React, { useEffect } from 'react';
export const DataGroup = t0 => {
  const $ = _c(11);
  const {
    docs,
    orderIndex,
    onClick
  } = t0;
  const [structuredDocs, setStructuredDocs] = React.useState(docs);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["md", "xl"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    isMd,
    isXl
  } = useMatchMedia(t1);
  const elementsInRow = isXl ? 3 : isMd ? 2 : 1;
  const start = orderIndex % elementsInRow + 1;
  let t2;
  let t3;
  if ($[1] !== docs || $[2] !== elementsInRow || $[3] !== start) {
    t2 = () => {
      setStructuredDocs(calculateBorders(docs, elementsInRow, start));
    };
    t3 = [docs, elementsInRow, start];
    $[1] = docs;
    $[2] = elementsInRow;
    $[3] = start;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== onClick || $[7] !== structuredDocs) {
    let t5;
    if ($[9] !== onClick) {
      t5 = (doc, index) => {
        const className = cn("border-2 bg-[#ebf8f0] border-dashed border-[#009639] p-1", {
          "border-t-transparent": !doc.borders?.top,
          "border-b-transparent": !doc.borders?.bottom,
          "border-l-transparent": !doc.borders?.left,
          "border-r-transparent": !doc.borders?.right,
          "mb-0.5": !!doc.borders?.bottom,
          "mr-0.5": !!doc.borders?.right,
          "ml-0.5": !!doc.borders?.left
        });
        const contentClassName = cn({
          "mt-[2px]": !doc.borders?.top,
          "mb-[2px]": !doc.borders?.bottom,
          "ml-[2px]": !doc.borders?.left,
          "mr-[2px]": !doc.borders?.right
        });
        if (doc.type === "metrics") {
          return <MetricCard onClick={() => {
            onClick(doc.raw.id);
          }} key={`group-metric-${index}`} className={className} contentClassName={contentClassName} parsedMetric={doc.value} rawMetric={doc.raw} />;
        }
        return <StatisticCard onClick={() => {
          onClick(doc.raw.id);
        }} key={`group-statistic-${index}`} className={className} contentClassName={contentClassName} data={doc.value} />;
      };
      $[9] = onClick;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = structuredDocs.map(t5);
    $[6] = onClick;
    $[7] = structuredDocs;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};